import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_TREND_DETAILS } from './url-constants';

type DeviceTrendsDetailsEndpointSpecification = ApiEndpointSpecification;
export const DeviceTrendsDetailsEndpointSpecification: DeviceTrendsDetailsEndpointSpecification = {
    url: DEVICE_TREND_DETAILS,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'DeviceTrendsDetailsRequestParams',
    requestBodySchemaName: 'DeviceTrendsDetailsRequestBody',
    okResponseSchemaName: 'DeviceTrendsDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeDeviceTrendsDetails = Helpers.makeApiRequestFn<
    Types.DeviceTrendsDetailsRequestParams,
    Types.DeviceTrendsDetailsRequestBody,
    Types.DeviceTrendsDetailsOkResponse
>(DeviceTrendsDetailsEndpointSpecification);
